
<template>
    <v-container fluid grid-list-xl class="login-container">
        <v-layout  row wrap>

            <v-flex lg3 md4 xs12 class="forgot-password-section padding-left-xl">
                <div class="logo-language-selection">
                    <img v-if="logo" v-bind:src="logo" alt="smass logo"  class="logo">
                </div>

                <div class="login-form">
                    <v-toolbar flat dense >
                        <v-toolbar-title class="font-size-big no-margin-left color-headings-text font-weight-bold">{{text("db.global.TYPE_GTS_FYP_TITLE_A")}}</v-toolbar-title>
                    </v-toolbar>
                    <div class="subtitle-info">{{text("db.global.TYPE_GTM_PAGE_FYP_HELPTEXT_1")}}</div>

                    <div class=" pb-2">
                        <v-form ref="loginForm" v-model="valid" class="margin-bottom-xl">

                            <div class="error" v-html="error"></div>

                            <div v-show="!isForgotPassFormSubmitted" class="forgot-pass-input-field">
                                <v-text-field
                                    type="text"
                                    name="email"
                                    :placeholder="text('api.registration.email')"
                                    v-model="email"
                                    :rules="validationRules.email"
                                    @keyup.enter="submitForgotPassForm"
                                ></v-text-field>
                            </div>

                            <v-btn v-show="!isForgotPassFormSubmitted" block @click="submitForgotPassForm" color="primary" class="forgot-btn accessibility-spacing-small" :disabled="!valid" >{{text('api.button.submit')}}</v-btn>

                            <p v-show="isForgotPassFormSubmitted">{{text("db.global.TYPE_GTM_FYP_SUCCESS_NOTIFICATION")}}</p>
                        </v-form>
                        <div class="color-body">
                            <router-link :to="'/'" class="underline-none color-primary">{{text("api.pro.forgotPass.returnToLogin")}}</router-link>
                        </div>
                    </div>
                </div>

                <div class="powered-by">
                    <span class="color-body font-weight-light">{{text('db.global.TYPE_GTS_COMMERCIAL_FIELD_TITLE')}} </span>
                    <in4-medicine-logo  class="margin-left-xxs"></in4-medicine-logo>
                </div>
            </v-flex>

            <v-flex lg9 md8 xs-hidden >
                <v-carousel hide-controls >

                    <v-carousel-item src="static/img/login_bg.jpg" transition="fade"
                                     reverse-transition="fade">
                        <h4>{{text('db.global.TYPE_GTS_HOME_TITLE_A')}}</h4>
                        <span v-html="text('db.global.TYPE_GTR_PAGE_HOME_TEXTFIELD_1')"></span>
                    </v-carousel-item>

                    <v-carousel-item src="static/img/login_bg.jpg" transition="fade"
                                     reverse-transition="fade">
                        <h4>{{text('db.global.TYPE_GTS_HOME_TITLE_B')}}</h4>
                        <span v-html="text('db.global.TYPE_GTR_PAGE_HOME_TEXTFIELD_2')"></span>
                    </v-carousel-item>

                </v-carousel>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import In4MedicineLogo from "../svg/shared/in4MedicineLogo";

    export default {
        name: 'ForgotPasswordPage',
        components: {
            In4MedicineLogo
        },
        data() {
            return {
                email: '',
                error: null,
                valid: true,
                isForgotPassFormSubmitted: false,

                validationRules: {
                    email: [
                        (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                        (value) => {
                            let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            return regex.test(value) || this.text("api.error.email.invalid");
                        }
                    ]
                }
            }
        },
        computed: {
            ...mapGetters({
                languageList: 'TranslationStore/getLanguageList',
                logo: 'TranslationStore/getLogo'
            }),

            languageListForDropdown () {

                let langsForDropdown = [];
                this.languageList.forEach((langKey) => {
                    langsForDropdown.push({
                        key: langKey,
                        name: this.text("api.language.name."+langKey)
                    });
                });
                return langsForDropdown;
            },

            selectedLang: {
                get () {
                    return this.$store.state["TranslationStore"].selectedLanguage;
                },
                set (newVal) {
                    this.$store.commit('TranslationStore/setSelectedLanguage', newVal);
                }
            }
        },

        beforeCreate() {
            this.isForgotPassFormSubmitted = false;
        },

        methods: {
            submitForgotPassForm () {
                this.$store.dispatch("UserStore/submitForgotPassword", {
                    value: this.email
                }).then((response) => {
                    this.isForgotPassFormSubmitted = true;
                });
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .container.login-container {
        padding: 0;
        height: 100%;

        .layout {
            height: 100%;
            margin: 0;

            .flex.forgot-password-section {
                padding: 40px 0;
                background-color: $color-block-background;
                position: relative;

                .logo-language-selection {
                    display: flex;


                    .logo {
                        height: 64px;
                        max-width: 195px;
                    }

                    .input-group--select {
                        padding-top: 0;
                        width: auto;
                        position: absolute;
                        right: 20px;
                        min-width: 120px;

                        .input-group__input .icon {
                            display: none;
                        }

                    }

                }

                .powered-by{
                    position: absolute;
                    bottom: 3%;
                    width: 75%;

                    svg {
                        width: 145px;
                        position: relative;
                        top: 8px;
                    }
                }

                .login-form {

                    form {

                        .forgot-pass-input-field {
                            position: relative;
                            display: flex;

                            img {
                                position: absolute;
                                top: 20px;
                                float: left;
                                width: 20px;
                            }

                            .input-group.input-group--text-field {
                                float: right;
                                width: 90%;

                            }
                        }

                        button {
                            height: 45px;
                            border-radius: 5px;

                            .btn__content {
                                font-size: $font-size-medium;
                                font-family: $font-weight-light;
                            }
                        }
                    }

                }

                .toolbar {
                    background-color: transparent;
                }
            }

            .flex {
                padding: 0;

                .carousel {
                    height: 100%;

                    .jumbotron__content{

                        h4 {
                            padding-bottom: 8px;
                            margin-bottom: 15px;

                            &:after {
                                content:"";
                                background: $color-brand-primary;
                                position: absolute;
                                top: 70px;
                                left: 37%;
                                height: 4px;
                                width: 25%;
                            }
                        }

                        span {
                            font-weight: $font-weight-light;
                        }
                    }
                }
            }

        }
    }


    @media only screen and (max-width: 600px) {

        .login-container {
            .layout .flex.forgot-password-section .login-form {

                width: 80%;
            }

            .logo-language-selection img {
                margin-right: 50px;
            }
        }

    }

    @media only screen and (min-width: 601px) and (max-width: 961px) {

        .login-container {
            .layout .flex.forgot-password-section .login-form {

                width: 90%;
            }

            .logo-language-selection img {
                margin-right: 150px;
            }
        }
    }


    @media only screen and (min-width: 962px) and (max-width: 1300px) {

        .login-container {

            .layout .flex.forgot-password-section .login-form {
                width: 80%;
            }

            .jumbotron__content {

                h4 {
                    font-size: 2rem;
                    // letter-spacing: 0.12 * 2rem;
                    // line-height: 1.5 * 2rem;
                    // word-spacing: 0.16 * 2rem;
                }

                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-medium;
                    // word-spacing: $word-spacing-medium;
                    // line-height: $line-height-medium;
                    // letter-spacing: $letter-spacing-medium;

                }
            }

            .logo-language-selection img {
                margin-right: 30px;
            }

            .powered-by svg {
                width: 125px;
                position: relative;
                top: 6px;
            }

        }

    }

    @media only screen and (min-width: 1201px) and (max-width: 1699px) {

        .login-container {

            .layout .flex.forgot-password-section .login-form {
                width: 80%;
            }

            .jumbotron__content {

                h4 {
                    font-size: 2.25rem;
                    // letter-spacing: 0.12 * 2.25rem;
                    // line-height: 1.5 * 2.25rem;
                    // word-spacing: 0.16 * 2.25rem;
                }

                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-medium;
                    // word-spacing: $word-spacing-medium;
                    // line-height: $line-height-medium;
                    // letter-spacing: $letter-spacing-medium;

                }
            }

            .logo-language-selection img {
                margin-right: 50px;
            }
        }
    }


    @media only screen and (min-width: 1700px) {

        .login-container {

            .layout .flex.forgot-password-section .login-form {
                width: 80%;
            }

            .jumbotron__content {

                h4 {
                    font-size: 2.625rem ;
                    // SMASSDEV - 1119
                    // word-spacing: 0.16 * 2.625rem;
                    // line-height: 1.5 * 2.625rem;
                    // letter-spacing: 0.12 * 2.625rem;
                }

                span {
                    // SMASSDEV - 1119
                    font-size: $font-size-big;
                    // word-spacing: $word-spacing-big;
                    // line-height: $line-height-big;
                    // letter-spacing: $letter-spacing-big;

                }
            }

            .logo-language-selection img {
                margin-right: 95px;
            }
        }
    }

    .fade-enter-active, .fade-leave-active, .fade-leave-to {
        position: absolute;
    }

    .forgot-btn {
        background-color: $color-brand-primary;
        color: $color-headings-text;
    }

    @media only screen and (max-height: 499px) {
        .login-container {
            .layout {
                position: fixed;
                width: 100%;
                overflow-y: auto;
            }
        }

    }
    @media only screen and (min-height: 500px) {
        .login-form {
            position: absolute;
            bottom: 27%;
        }

        .subtitle-info {
            font-size: $font-size-small;
            font-style: italic;
            margin-top: -10px;
            margin-bottom: 30px;
            color: #98a5a8;
        }
    }
</style>





// WEBPACK FOOTER //
// src/common/components/forgot-password/ForgotPasswordPage.vue